import * as React from "react";
const SvgWifi = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.536 8.024C4.776 5.732 8.173 4.25 12 4.25c3.827 0 7.223 1.482 9.464 3.774a.75.75 0 0 0 1.072-1.048C19.998 4.379 16.208 2.75 12 2.75c-4.208 0-7.998 1.629-10.536 4.226a.75.75 0 1 0 1.072 1.048ZM11.25 19a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm0-7.5c-2.656 0-4.987.918-6.492 2.302a.75.75 0 0 1-1.016-1.104C6.308 8.778 9.016 7.75 12 7.75s5.692 1.029 7.508 2.698a.75.75 0 1 1-1.015 1.104C16.986 10.168 14.655 9.25 12 9.25Zm-2.975 6.035c.602-.59 1.68-1.035 2.975-1.035 1.296 0 2.373.445 2.975 1.035a.75.75 0 1 0 1.05-1.07c-.938-.92-2.422-1.465-4.025-1.465-1.603 0-3.087.544-4.025 1.465a.75.75 0 1 0 1.05 1.07Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgWifi;
